import { forwardRef } from 'react';

import { TextFieldProps } from '@mui/material';

import { InputField as InputFieldStyled } from './input-field-styles';

const InputField = forwardRef<HTMLInputElement, TextFieldProps>((props, ref) => {
  return <InputFieldStyled {...props} inputRef={ref} />;
});

InputField.displayName = 'InputField';

export default InputField;
